import { datadogRum } from "@datadog/browser-rum";
import { getAppType } from "utils/helper";
import { getCompanyId } from "utils/idHelpers";

export const trackPageViewUserStep = (
  stepNumber: number,
  stepName: string,
  version?: number
) => {
  datadogRum.addAction("wisteria-wombat-fe-trackPageViewUserStep", {
    stepNumber,
    stepName,
    appName: getAppType(),
    companyId: getCompanyId(),
    device: navigator.userAgent,
    version: version || 0,
  });
};

export const trackSaveAndContinueUserStep = (
  stepNumber: number,
  stepName: string,
  version?: number
) => {
  datadogRum.addAction("wisteria-wombat-fe-trackSaveAndContinueUserStep", {
    stepNumber,
    stepName,
    appName: getAppType(),
    companyId: getCompanyId(),
    device: navigator.userAgent,
    version: version || 0,
  });
};

export const trackFormSubmission = (
  stepNumber: number,
  stepName: string,
  version?: number
) => {
  datadogRum.addAction("wisteria-wombat-fe-trackFormSubmission", {
    stepNumber,
    stepName,
    appName: getAppType(),
    companyId: getCompanyId(),
    device: navigator.userAgent,
    version: version || 0,
  });
};

export const trackFormError = (error: Error, errorMessage: string) => {
  datadogRum.addError(error, {
    message: errorMessage,
    companyId: getCompanyId(),
    device: navigator.userAgent,
    appName: getAppType(),
  });
};

export const trackCoreAppFormError = (missingFieldNames: string[]) => {
  const formattedFieldNames = missingFieldNames.join(", ");

  datadogRum.addError("missing-core-app-field-validation-error", {
    message: `Unable to proceed because of missing field: ${formattedFieldNames}`,
    companyId: getCompanyId(),
    device: navigator.userAgent,
    appName: getAppType(),
  });
};

export const trackStepperError = (errorMessage: string) => {
  datadogRum.addError("uuid-not-found", {
    message: errorMessage,
    companyId: getCompanyId(),
    device: navigator.userAgent,
    appName: getAppType(),
  });
};

export const trackAddressValidationEvents = (errorMessage: string) => {
  datadogRum.addAction("invalid-address", {
    message: errorMessage,
    companyId: getCompanyId(),
    device: navigator.userAgent,
    appName: getAppType(),
  });
};

export const trackBrokenKafkaPrefills = (errorMessage: string) => {
  datadogRum.addAction("broken-kafka-prefill", {
    message: errorMessage,
    companyId: getCompanyId(),
    device: navigator.userAgent,
    appName: getAppType(),
  });
};

export const trackCensusTableSubmission = ({
  drawerVariant,
  dependentCount,
  employeeCount,
  isCobra,
}: {
  drawerVariant: string;
  dependentCount: number;
  employeeCount: number;
  isCobra: boolean;
}) => {
  datadogRum.addAction("hi-drawer-ab-submission", {
    drawerVariant,
    dependentCount,
    employeeCount,
    isCobra,
    appName: getAppType(),
    companyId: getCompanyId(),
    device: navigator.userAgent,
  });
};

export const trackCensusTableView = ({
  drawerVariant,
  isCobra,
}: {
  drawerVariant: string;
  isCobra: boolean;
}) => {
  datadogRum.addAction("hi-drawer-ab-view", {
    drawerVariant,
    isCobra,
    appName: getAppType(),
    companyId: getCompanyId(),
    device: navigator.userAgent,
  });
};

export const trackNewStepCompleted = (stepName: string) => {
  datadogRum.addAction("new-step-version-completed", {
    stepName,
    appName: getAppType(),
    companyId: getCompanyId(),
    device: navigator.userAgent,
  });
};
